import React, { useEffect, useState } from 'react';
import { TranslationProvider } from './hooks/useTranslations';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { BenefitsTicker } from './components/BenefitsTicker';
import { ValueProposition } from './components/ValueProposition';
import { FundingSolutions } from './components/FundingSolutions';
import { HowItWorks } from './components/HowItWorks';
import { Requirements } from './components/Requirements';
import { TrustSecurity } from './components/TrustSecurity';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { MapLocation } from './components/MapLocation';
import { Footer } from './components/Footer';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsConditions } from './components/TermsConditions';
export function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'privacy' | 'terms'>('home');
  useEffect(() => {
    // Handle hash-based routing
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash === '#/privacy') {
        setCurrentPage('privacy');
      } else if (hash === '#/terms') {
        setCurrentPage('terms');
      } else {
        setCurrentPage('home');
      }
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  const navigateToHome = () => {
    window.location.hash = '';
    setCurrentPage('home');
    window.scrollTo(0, 0);
  };
  const navigateToPrivacy = () => {
    window.location.hash = '#/privacy';
    setCurrentPage('privacy');
    window.scrollTo(0, 0);
  };
  const navigateToTerms = () => {
    window.location.hash = '#/terms';
    setCurrentPage('terms');
    window.scrollTo(0, 0);
  };
  return <TranslationProvider data-id="element-0">
      <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#00E676] selection:text-white" data-id="element-1">
        {currentPage === 'home' && <>
            <Navbar data-id="element-2" />
            <main data-id="element-3">
              <Hero data-id="element-4" />
              <BenefitsTicker data-id="element-5" />
              <ValueProposition data-id="element-6" />
              <FundingSolutions data-id="element-7" />
              <HowItWorks data-id="element-8" />
              <Requirements data-id="element-9" />
              <TrustSecurity data-id="element-10" />
              <FAQ data-id="element-11" />
              <Contact data-id="element-12" />
              <MapLocation data-id="element-13" />
            </main>
            <Footer onPrivacyClick={navigateToPrivacy} onTermsClick={navigateToTerms} data-id="element-14" />
          </>}

        {currentPage === 'privacy' && <PrivacyPolicy onBack={navigateToHome} data-id="element-15" />}
        {currentPage === 'terms' && <TermsConditions onBack={navigateToHome} data-id="element-16" />}
      </div>
    </TranslationProvider>;
}